import React from 'react';
import styles from './solution-features.module.scss';
import { useAppMediaQuery } from 'shared/hooks';

interface IFeature {
  badge: string;
  title: string;
  description: string;
  image: string;
  reversed: boolean;
}

export const SolutionFeatures: React.FC = () => {
  const isMobile = useAppMediaQuery('mobileL');

  const features: IFeature[] = [
    {
      badge: '24/7',
      title: 'Онлайн-запись на всех площадках',
      description:
        'Виджет на сайт, VK-бот, прямая ссылка. Клиент выбирает услугу, мастера и время за 3 клика. Работает на телефоне и компьютере.',
      image: '/screenshots/customer-booking.png',
      reversed: false,
    },
    {
      badge: 'Бесплатно',
      title: 'Автоматические напоминания в VK',
      description:
        'Система сама напомнит клиенту о визите прямо во ВКонтакте. Клиент может подтвердить, перенести или отменить запись в чате с ботом.',
      image: '/screenshots/point-page.png',
      reversed: true,
    },
    {
      badge: 'Яндекс',
      title: 'Интеграция с Яндекс Картами',
      description:
        'Кнопка "Записаться онлайн" на карточке вашего салона в Яндекс Картах. Приток новых клиентов из поиска. Подключим бесплатно по запросу.',
      image: '/screenshots/business-dashboard.png',
      reversed: false,
    },
  ];

  return (
    <div className={styles.solution_features_outer}>
      <div id="solution-features" className={styles.solution_features}>
        <h2 className={styles.solution_features__title}>
          Онлайн-запись, аналитика и учёт в одном окне
        </h2>
        <div className={styles.solution_features__cards}>
          {features.map((feature, index) => (
            <div
              key={index}
              className={`${styles.feature_card} ${feature.reversed ? styles['feature_card--reversed'] : ''}`}
            >
              <div className={styles.feature_card__text}>
                <span className={styles.feature_badge}>{feature.badge}</span>
                <div className={styles.feature_title}>{feature.title}</div>
                <div className={styles.feature_description}>
                  {feature.description}
                </div>
              </div>
              {!isMobile && (
                <div className={styles.feature_card__visual}>
                  <img src={feature.image} alt={feature.title} />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
